import * as types from '../constants/claimStatusTypes';
import * as events from '../constants/formEvents';

export function getNewClaimStatus(currentClaimStatus, event, eventType) {
  let newClaimStatus;

  switch (currentClaimStatus) {
    case types.CLAIM_STATUS_INITIATED:
      if (eventType === events.FORM_EVENT_SAVECONTINUELATER) {
        newClaimStatus = types.CLAIM_STATUS_IN_PROGRESS;
      } else if (eventType === events.FORM_EVENT_PERIODICSAVE) {
        newClaimStatus = types.CLAIM_STATUS_INITIATED;
      } else if (eventType === events.FORM_EVENT_LEAVINGPAGE) {
        newClaimStatus = types.CLAIM_STATUS_INITIATED;
      } else { // on Next button
        newClaimStatus = types.CLAIM_STATUS_IN_PROGRESS;
      }
      break;
    case types.CLAIM_STATUS_IN_PROGRESS:
      newClaimStatus = types.CLAIM_STATUS_IN_PROGRESS;
      break;
    case types.CLAIM_STATUS_SUBMITTED:
      newClaimStatus = types.CLAIM_STATUS_SUBMITTED;
      break;
    case types.CLAIM_STATUS_EXPIRED:
      newClaimStatus = types.CLAIM_STATUS_EXPIRED;
      break;
    case types.CLAIM_STATUS_CANCELLED:
      newClaimStatus = types.CLAIM_STATUS_CANCELLED;
      break;
    case types.CLAIM_STATUS_EXITED:
      newClaimStatus = types.CLAIM_STATUS_EXITED;
      break;
    default: // FE limits client to update claims only with status In-progress
      if (eventType === events.FORM_EVENT_SAVECONTINUELATER) {
        newClaimStatus = types.CLAIM_STATUS_IN_PROGRESS;
      } else if (eventType === events.FORM_EVENT_PERIODICSAVE) {
        newClaimStatus = types.CLAIM_STATUS_IN_PROGRESS;
      } else if (eventType === events.FORM_EVENT_LEAVINGPAGE) {
        newClaimStatus = types.CLAIM_STATUS_IN_PROGRESS;
      } else {
        newClaimStatus = types.CLAIM_STATUS_IN_PROGRESS;
      }
      break;
  }

  return newClaimStatus;
}
